import { InventoryLevelSchema } from "@redotech/redo-model/inventory/inventory";
import {
  Product2Schema_,
  Product2VariantSchema_,
} from "@redotech/redo-model/product2/product2-types";
import { WarehouseSchema } from "@redotech/redo-model/warehouse/warehouse-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const InventoryLevelWithWarehouseSchema = InventoryLevelSchema.extend({
  warehouse: WarehouseSchema,
});

export const VariantWithInventorySchema = Product2VariantSchema_.extend({
  inventoryLevels: z.array(InventoryLevelWithWarehouseSchema),
  available: z.number().min(0).default(0),
  committed: z.number().min(0).default(0),
});
export const ProductWithInventorySchema = Product2Schema_.extend({
  variants: z.array(VariantWithInventorySchema),
});
export type ProductWithInventory = z.infer<typeof ProductWithInventorySchema>;

export const getMerchantInventory = {
  name: "getMerchantInventory" as const,
  input: z.object({
    pageSize: z.number().optional(),
    page: z.number().optional(),
    search: z.string().optional(),
    warehouseIds: z.array(zExt.objectId()).optional(),
  }),
  output: z.object({
    products: z.array(ProductWithInventorySchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
};
